
import React from "react";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Loader2 } from "lucide-react";

export type Client = {
  id: string;
  name: string;
  avatar: string;
  email?: string;
  phone?: string;
  age?: number;
  gender?: string;
  goals?: string;
  notes?: string;
};

type ClientSelectionProps = {
  clients: Client[];
  isLoading: boolean;
  onClientSelect: (clientId: string) => void;
};

export default function ClientSelection({
  clients,
  isLoading,
  onClientSelect
}: ClientSelectionProps) {
  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-8 w-8 text-white animate-spin" />
          <span className="ml-2 text-white">Loading clients...</span>
        </div>
      ) : (
        <Card className="backdrop-blur-lg bg-white/10 border-white/20">
          <CardHeader>
            <CardTitle className="text-white">Select a Client</CardTitle>
            <CardDescription className="text-white/70">
              Choose a client to create a program for
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="w-full max-w-sm">
              <Select onValueChange={onClientSelect}>
                <SelectTrigger className="w-full bg-white/10 border-white/30 text-white">
                  <SelectValue placeholder="Select a client" />
                </SelectTrigger>
                <SelectContent>
                  {clients.map(client => (
                    <SelectItem key={client.id} value={client.id}>
                      <div className="flex items-center gap-2">
                        <Avatar className="h-6 w-6">
                          {client.avatar && client.avatar !== "/placeholder.svg" && (
                            <AvatarImage src={client.avatar} />
                          )}
                          <AvatarFallback>
                            {client.name.split(' ').map(n => n[0]).join('')}
                          </AvatarFallback>
                        </Avatar>
                        <span>{client.name}</span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
